export default __webpack_public_path__ + "static/media/kitten4XXS.1f6d5326.webp";